import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=42c676c5&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=42c676c5&prod&scoped=true&lang=css"
import style1 from "./reg.vue?vue&type=style&index=1&id=42c676c5&prod&lang=css"
import style2 from "./reg.vue?vue&type=style&index=2&id=42c676c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c676c5",
  null
  
)

export default component.exports